import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { ViewImageComponent } from '../components/view-image/view-image.component';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  constructor(private _ds: ApiService,
    private modalService: NgbModal
  ) { }

  readDoc(fileInput: any, cb: any) {
    const vm = this;
    if (fileInput.target.files && fileInput.target.files[0]) {
      const image = fileInput.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const file = e.target.result;
        if (((file.includes('application/pdf')) || file.includes('image/png') || file.includes('image/jpeg'))) {
          cb(e.target.result);
        } else {
          cb(false);
        }
      };
      reader.readAsDataURL(image);
    } else {
      cb(false);
    }
  }

  uploadDocAPICall(image: string, cb: any) {
    const vm = this;
    const req = { file: image }
    vm._ds.postData('/document/upload', req).subscribe((res: any) => {
      if (res && !res.error) {
        cb(res.data);
      } else {
        cb(false);
      }
    });
  }

  fetchAndViewDoc(docId: any) {
    const vm = this;
    vm._ds.getData('/document/fetch/' + docId).subscribe((res: any) => {
      const modalRef = vm.modalService.open(ViewImageComponent, { backdrop: 'static', size: 'lg' });
      modalRef.componentInstance.doc = res.data;
    });
  }

  deleteDoc(mongoIds: any, cb: any) {
    const vm = this;
    const apiArray = [];
    if (mongoIds && Array.isArray(mongoIds) && mongoIds.length > 0) {
      mongoIds.forEach((id: string) => {
        apiArray.push(vm._ds.getData('/document/delete/' + id));
      });
    } else {
      apiArray.push(vm._ds.getData('/document/delete/' + mongoIds));
    }
    forkJoin(apiArray).subscribe(res => {
      cb(true);
    });
  }
}
